import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { ListGroup, Button } from 'react-bootstrap'
import * as s from './FAQ.scss'
import { getFootballFaq } from '@severed-links/common.redherrings-reducers/football'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'

const FAQ = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const faq = useSelector(state => state.football.faq)

    useEffect(() => { dispatch(getFootballFaq()) }, [])

    return (
        <div className={s.container}>
            <div className={s.hero}>
                <div className={s.heroIcon}><FontAwesomeIcon name='question-circle' /></div>
                <div>
                    <div className={s.eyebrow}>Football</div>
                    <h2 className={s.title}>FAQs</h2>
                    <div className={s.subtitle}>Answers for picks, scoring, payouts, and league logistics.</div>
                </div>
            </div>
            <ListGroup className={s.questionList}>
            {faq && faq.map(i =>
            <ListGroup.Item className={s.questionItem} key={`football-faq-${i._id}`}>
                {i.question ? <h4 className={s.question}>{i.question}</h4> : null}
                {i.answer ? <div className={s.answer}>{i.answer}</div> : null}
                {i.link ? <div><a href={i.link} target='_blank'>{i.linkTitle || 'Read more...'}</a></div> : null}
                {i.button ? <div><Button onClick={() => navigate(i.button.webPath)}>{i.button.title}</Button></div> : null}
            </ListGroup.Item>
            )}
            </ListGroup>
            <h4 className={s.question}>Enjoy.</h4>

        </div>
    )
}

export default FAQ
